const GROUP_ROW_COLOR = "color-mix(in oklch, hsl(var(--primary)) 25%, white)";
const GROUP_ROW_DIVIDER_COLOR = "color-mix(in oklch, hsl(var(--primary)) 45%, white)";

// Group header rows hide their borders by matching the background. A collapsed group (header not
// followed by one of its member rows) keeps a visible bottom border so consecutive collapsed
// groups don't merge into one block.
export const hasGroupDivider = (resources: any[], index: number) => {
    const next = resources[index + 1];
    return !!resources[index]?.isHeader && (!next || !!next.isHeader);
};

export const getGroupRowStyle = (withDivider?: boolean) => ({
    backgroundColor: GROUP_ROW_COLOR,
    borderRightColor: GROUP_ROW_COLOR,
    borderBottomColor: withDivider ? GROUP_ROW_DIVIDER_COLOR : GROUP_ROW_COLOR
});
